export default () => ({
  trigger: {
    name: 'image_gallery.show_image_gallery',
    params: {},
  },
  config: {
    event: {
      name: 'show_content',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
